module.exports = {
	methods: {
		chunkMap: function (map, chunkSize) {
			
			let values = Object.values(map);
			let final = [];
			let counter = 0;
			let portion = {};
			
			for (let key in map) {
				if (counter !== 0 && counter % chunkSize === 0) {
					final.push(portion);
					portion = {};
				}
				portion[key] = values[counter];
				counter++
			}
			final.push(portion);
			
			return final;
		},
		
		charLimit: function(string, charCount){
			return string.substring(0, charCount) + '...';
		},
		
		ucfirst: function(string){
			return string.charAt(0).toUpperCase() + string.slice(1);
		},

        getRandomInt(max) {
            return Math.floor(Math.random() * Math.floor(max)) + 1 ;
        },

        getFallBackImage(){
            return `/images/GEN BAG C${this.getRandomInt(4)} mini.jpg`
        }
	}
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/Helpers.js